// Minimal old-school HTML theme - Dark (inverted colors)

export const dark = {
    'background1': '#000000',
    'background2': '#000000',
    'text1': '#00ff00',
    'text2': '#00ff00',

    "navLink": {
        color: '#00ffff',
    },

    "activeTab": {
        color: "#00ff00",
        background: "transparent",
        fontWeight: "bold",
        textDecoration: "none",
        padding: "5px 10px",
    },

    "notActiveTab": {
        color: "#00ffff",
        background: "transparent",
        textDecoration: "underline",
        padding: "5px 10px",
    },

    ".notActiveTab:hover": {
        color: "#ffff00",
    },

    "workCard": {
        border: "1px solid #00ff00",
        background: "#000000",
        padding: "15px",
        marginBottom: "20px",
    },

    "workCardDetails ": {
        background: "#000000",
        padding: "10px 0",
    },

    "contactMeForm": {
        border: "1px solid #00ff00",
        background: "#000000",
        padding: "20px",
    },

    "input": {
        color: "#00ff00",
        border: "1px solid #00ff00",
        background: "#000000",
        padding: "5px",
        fontFamily: '"Courier New", Courier, monospace',
    }
}
